<template>
    <div
        v-if="doctor.is_device_timezone != 1 && isCloseNotification.timezone === false && !isMatchTimezone"
        class="vc-notification vc-notification--danger d-flex justify-content-between align-items-center">
        <div>
            <span class="vc-notification__text text-danger">
                <b-icon-exclamation-triangle-fill/>{{ $locale.appName }}に設定中のタイムゾーンと、デバイスのタイムゾーンが異なるようです。
            </span>
            <b-button
                class="vc-notification__btn"
                size="sm"
                variant="yokumiru-ash"
                href="/doctor/profile">
                確認する
            </b-button>
        </div>
        <div
            class="vc-notification__close"
            @click="isCloseNotification.timezone = true">
            <span>&times;</span>
        </div>
    </div>
</template>

<script>
    import moment from 'moment-timezone'

    export default {
        props: {
            doctor: {
                type: Object,
                required: true,
            },
        },

        data: function () {
            return {
                isCloseNotification: {
                    timezone: false,
                },
            }
        },

        computed: {
            deviceTimezone: function () {
                return moment.tz.guess()
            },

            isMatchTimezone: function () {
                if (!this.doctor) return true
                return this.deviceTimezone === this.doctor.timezone
            },
        },
    }
</script>

<style lang="scss" scoped>
.vc-notification {
    margin-bottom: 12px;
    padding: 9px 10px;
    border: 2px solid #86ccda;
    border-radius: 5px;

    .vc-notification__text {
        font-size: .875rem;

        svg {
            margin-right: 4px;
            fill: #f79e08;
        }
    }

    .vc-notification__btn {
        padding: 2px 6px;
        font-size: .75rem;
    }

    .vc-notification__close {
        position: relative;
        width: 20px;
        height: 20px;
        min-width: 20px;
        color: #fff;
        line-height: 19px;
        font-weight: bold;
        text-align: center;
        border-radius: 50%;
        cursor: pointer;
        background: #86CCDA;
    }

    &.vc-notification--danger {
        border: 2px solid #dc3545;

        .vc-notification__close {
            background: #DC3545;
        }
    }
}
</style>
